import { Button } from "client/Components";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import styles from "./TileRefresh.module.less";

export type TileRefreshProps = {
	onRefresh: () => void;
};

export const TileRefresh = (props: TileRefreshProps): ReactElement => {
	const {
		onRefresh
	} = props;

	return (
		<div className={styles.root}>
			<p className={styles.message}>
				{localize("_UnableToRetrieveDataPleaseRefreshTheTile")}
			</p>
			<div className={styles.button}>
				<Button
					kind="primary"
					color="app"
					text={localize("_RefreshTile")}
					onClick={onRefresh}
				/>
			</div>
		</div>
	);
};
TileRefresh.displayName = "TileRefresh";

